import {useEffect, useRef} from 'react'
import {Map as LeafletMap, MapOptions as LeafletMapOptions} from 'leaflet'
import {useLeafletInstance} from 'src/hooks/dom'

type GoogleMapProps = {
  id?: string
  mapContainerStyle?: any
  initialZoom: number
  initialCenter: {lat: number; lng: number}
  options?: LeafletMapOptions
  onMapLoaded?: (map: LeafletMap) => void
  noZoom?: boolean
}

//no events right on the map so its performant
export default function LocationMap(props: GoogleMapProps) {
  const leafletInstance = useLeafletInstance()
  const mapDivRef = useRef<HTMLDivElement | null>(null)
  const mapRef = useRef<null | LeafletMap>(null)

  useEffect(() => {
    if (!mapDivRef.current) return
    if (!leafletInstance) return

    //dont recreate
    if (mapRef.current) {
      return
    }

    mapRef.current = leafletInstance.map(mapDivRef.current, {
      center: props.initialCenter,
      zoom: props.initialZoom,
      attributionControl: false,
      zoomControl: false, //remove the default one since we change it
      //mapId: props.mapId,
      ...props.options,
    })

    if (!props.noZoom) {
      leafletInstance.control
        .zoom({
          position: 'bottomright',
        })
        .addTo(mapRef.current)
    }

    //load default openstreet map
    leafletInstance
      .tileLayer(`https://tile.openstreetmap.org/{z}/{x}/{y}.png`, {
        minZoom: 2,
        maxZoom: 19,
        attribution: '',
        detectRetina: true,
        //  subdomains: ['a', 'b', 'c'],
      })
      .addTo(mapRef.current)

    mapRef.current?.whenReady(() => {
      if (props.onMapLoaded && mapRef.current) {
        props.onMapLoaded(mapRef.current)
      }
    })

    return () => {
      //todo delete map
      // mapRef.current
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leafletInstance, mapDivRef.current])

  return <div ref={mapDivRef} id={props.id} style={props.mapContainerStyle} />
}
